/*
 // THE FOLLOWING SHOULD BE PLACED IN THE IFRAME:
 (https://hqrs.notion.site/Analytics-Conversion-Tracking-99584e4854fb44a19d2a46a52e322f62)

<!-- Google Tag Manager - PageView Event (Travanto Ticket #TR-32788) -->
<script>
// Send iframe pageview event to the parent window
window.onload = function() {
    try {
        var path = window.location.pathname;
        if (path.indexOf('/public/car-rental/reservations/online-payments/') === 0) {
            path = '/public/car-rental/reservations/step6';
        }
        window.parent.postMessage({
            event: 'iframePageView',
            path: path
        }, '*');
    } catch (e) {
        window.console && window.console.log(e);
    }
};
</script>
<!-- End Google Tag Manager -->
*/

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { currentPortal } = usePortals()

  const portalValue = currentPortal.value as any
  const isSyltTravel = portalValue?.portal?.portal === 'http://www.sylt-travel.de'
  const isMietwagen = isSyltTravel && route.path.startsWith('/mietwagen/')

  if (!isMietwagen) {
    return
  }

  const { $gtmModules } = useNuxtApp() as any
  const ALLOWED_ORIGIN = 'https://travanto.sylt-travel.de'
  const MIETWAGEN_PATH = '/mietwagen'

  function handleMessage (event: MessageEvent) {
    // Security check - only allow messages from the iframe's origin
    if (!event.origin) {
      return
    }
    if (event.origin !== ALLOWED_ORIGIN) {
      return
    }

    if (event.data.event === 'iframePageView') {
      const pagePath: string = event.data.path || ''
      $gtmModules.mietwagen.sendIframePageViewEvent(
        window.location.origin + MIETWAGEN_PATH + pagePath,
        MIETWAGEN_PATH + pagePath
      )
    }
  }

  const nuxtApp = useNuxtApp()
  nuxtApp.hook('app:beforeMount', () => {
    window.addEventListener('message', handleMessage)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('message', handleMessage)
  })
})
